module.exports = __webpack_public_path__ + "img/pt9.ececce7b.png";